import React, { useState, useEffect } from "react";
import styles from "./Assessment.module.css";

const ExecutionBanner = ({ run, onCancel }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  // Timer effect
  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      setElapsedTime(((Date.now() - startTime) / 1000).toFixed(1));
    }, 100);

    return () => clearInterval(interval);
  }, []);

  if (!run) return null;

  const { state, total_cases, completed_cases, passed_cases } = run;
  const progress = total_cases > 0 ? (completed_cases / total_cases) * 100 : 0;

  const getStateLabel = () => {
    switch (state) {
      case "queued":
        return "Queued — waiting for sandbox";
      case "provisioning":
        return "Provisioning sandbox environment";
      case "running":
        return `Running your code — test ${completed_cases + 1} of ${total_cases}`;
      case "grading":
        return "Grading & calculating score";
      default:
        return "Processing...";
    }
  };

  const getStateSubtitle = () => {
    switch (state) {
      case "queued":
        return "Your code is in the queue. This usually takes a few seconds.";
      case "provisioning":
        return "Setting up the execution environment. Almost ready.";
      case "running":
        return "Executing on the sandbox. You can keep editing; the run is queued against this snapshot.";
      case "grading":
        return "All tests completed. Calculating your final score.";
      default:
        return "";
    }
  };

  const stages = [
    { id: "queued", label: "Snapshot queued", done: ["provisioning", "running", "grading", "done"].includes(state) },
    { id: "provisioning", label: "Sandbox provisioned", done: ["running", "grading", "done"].includes(state) },
    { id: "running", label: `Executing test cases (${completed_cases} / ${total_cases})`, done: state === "grading" || state === "done" },
    { id: "grading", label: "Grading & scoring", done: state === "done" },
  ];

  return (
    <div className={styles.executionBannerWrapper}>
      {/* Compact Banner */}
      <div className={styles.executionBanner}>
        <div className={styles.spinner} />
        <div className={styles.bannerContent}>
          <div className={styles.bannerTitle}>{getStateLabel()}</div>
          <div className={styles.bannerSubtitle}>{getStateSubtitle()}</div>
        </div>
        <div className={styles.bannerTimer}>{elapsedTime}s</div>
        <button className={styles.cancelBtn} onClick={onCancel}>
          Cancel
        </button>
      </div>

      {/* Progress Bar */}
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Compact stage indicators */}
      <div className={styles.stageIndicators}>
        {stages.map((stage) => {
          const isCurrent = stage.id === state;
          const isDone = stage.done;
          return (
            <div
              key={stage.id}
              className={`${styles.stageChip} ${isDone ? styles.stageDone : isCurrent ? styles.stageCurrent : styles.stagePending}`}
            >
              {isDone ? "✓" : isCurrent ? "●" : "○"} {stage.label.split(" (")[0]}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExecutionBanner;
